export default "__VITE_ASSET__NB6A4PeJDEESnqQnqz0_Dw__"